import { all, call, put, takeLatest } from 'redux-saga/effects'
import { basketProviderActions } from 'astra-core/containers/BasketProvider/slice'
import {
  EFeatureFlags,
  isFeatureFlagEnabled
} from 'astra-core/containers/ConfigProvider'

export function* resetBasketStateSaga() {
  const skipResetBasketState = yield call(
    isFeatureFlagEnabled,
    EFeatureFlags.SKIP_RESET_BASKET_STATE
  )
  if (!skipResetBasketState) {
    return
  }
  yield put(
    basketProviderActions.resetStateWithSavedFields({
      fields: [
        'layout.coefficientStatusOnChanged',
        'layout.isShowMakeBasketSuccessMessage'
      ]
    })
  )
}

export function* basketContainerSaga() {
  yield all([
    takeLatest(
      basketProviderActions.readyForBasketReset.type,
      resetBasketStateSaga
    )
  ])
}
